/**
 * Pillola di stato: tono, punto e capitoletto. Il colore e' il dato (§ 6.3).
 */
export type PillTone = 'ref' | 'sev-0' | 'sev-1' | 'sev-2' | 'sev-3' | 'sev-4' | 'st-lock' | 'ink-3'

export function StatusPill({
  label,
  tone,
  pulse = false,
}: {
  label: string
  tone: PillTone
  pulse?: boolean
}): JSX.Element {
  return (
    <span className={`status-pill tone-${tone}`}>
      <span className={pulse ? 'dot pulse' : 'dot'} aria-hidden="true" />
      {label}
    </span>
  )
}
